
<template>
  <div class="buffer-view">
    <div :v-if="title" class="title">{{title}}</div>
    <div ref="plot" class="buffer-chart"></div>
  </div>

</template>

<script>
import PlayerComponent from '../PlayerComponent.vue';
import { StatePlot } from '../../../utils/plots';

export default {
  extends: PlayerComponent,
  props: {
    title: {
      type: String,
      default: ''
    },
    xaxis: {
      type: Boolean,
      default: true
    }
  },
  name: 'PlotState',
  data () {
    return {
      currentBufferSize: 0,
      schedulePush: false
    };
  },
  mounted () {
    this.plot = new StatePlot(this.$refs.plot, this.xaxis);
    this.plot.init();
    this.plot.start();
    this.onStateChange();
  },
  destroyed () {
    this.plot.stop();
  },
  methods: {
    initPlayer (ppPlayerRef) {
      ppPlayerRef.get().on('statechanged', this.onStateChange);
    },
    disposePlayer (ppPlayerRef) {
      ppPlayerRef.get().off('statechanged', this.onStateChange);
    },
    onStateChange () {
      if (!this.plot || !this.ppPlayerRef) return;
      const state = this.ppPlayerRef.get().getState();
      this.plot.addSample(state);
      if (state === clpp.Player.State.ENDED) {
        this.plot.stop();
      } else {
        this.plot.start();
      }
    }
  }
};
</script>

<style lang="scss" scoped>

  @import 'src/style/color_';

  .buffer-view {
    position: relative;
  }

  .buffer-chart {
    height: 50px;
  }

  .title {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    font-size: 1rem;
    margin-left: 0;
    color: $color-secondary;
  }
</style>
